module.exports = __webpack_public_path__ + "img/ibc-international-bio-cosmetics-aloe-vera.dd46171f.jpg";